import moment from 'moment';

const hostname =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_HOSTNAME?.length > 0
      ? process.env.REACT_APP_HOSTNAME
      : window.location.hostname
    : process.env.REACT_APP_HOSTNAME_LOCAL?.length > 0
    ? process.env.REACT_APP_HOSTNAME_LOCAL
    : window.location.hostname;

const port =
  process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PORT : 8081;



export const BASE_LOCATION = window.location.protocol
  .concat('//')
  .concat(window.location.host);

export const BASE_RESOURCE_URL = window.location.protocol
  .concat('//')
  .concat(hostname)
  .concat(`:${port}`);

export const BASE_URL = window.location.protocol
  .concat('//')
  .concat(hostname)
  .concat(`:${port}/api`);


// export const BASE_URL = 'http://localhost:8080/api'

export const potentialRiskId = 1;
export const incurredRiskId = 2;
export const courtRiskId = 3;

export const BASE_URL_CHAT = window.location.protocol
  .concat('//')
  .concat(hostname)
  .concat(`:${port}/websocket`);

export const token = localStorage.getItem('jwt-token-risk');

export const webSocketToken = localStorage.getItem('webSocket_token_risk');



export const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);

export const isoDate = RegExp(
  /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/
);

export const isValidDate = RegExp(
  /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/
);


export const validUsernameRegex = RegExp(
  /^[_.@A-Za-z0-9-ŠšĐđČčĆćŽžџЏШшЂђЧчЋћЖжЉљЊњаАбБвВјЈгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУѕЅфФхХџЏцЦчЧшШщЩъЪыЫьЬэЭюЮяЯЉљЊњХх]*$/
);
export const validNameRegex = RegExp(
  /^[.A-Za-z-ŠšĐđČčĆćŽžШшЂђџЏЧчЋћЖжаАбБвВгГдДеЕёЁжЖзЗјЈиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧѕЅшШщЩџЏъЪыЫьЬэЭюЮяЯЉљЊњХх ]*$/
);
export const validNameRegex2 = RegExp(
  /^[A-Za-zŠšĐđČčĆćŽžШшЂђџЏЧчЋћЖжаАбБвВгГдДеЕёЁжЖзЗјЈиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧѕЅшШщЩџЏъЪыЫьЬэЭюЮяЯЉљЊњХх ]*$/
);
export const validNumberRegex = RegExp(/^[0-9]*$/);
export const validAbbriviationRegex = RegExp(/^[A-Z]{3}$/);

export const validDouble = RegExp(/^[0-9]*([.][0-9][0-9]?)?$/);
// export const validDouble = RegExp( /^(\d{1,3}(\.\d{3})*|\d+)(,\d{1,2})?$/);
export const validCode = RegExp(/^[a-zA-Z,_-]*$/);

export const validCyr = RegExp(
  /^[0-9ЉљЊњЕеРрТтЗзУуИиОоПпШшЂђЖжАаСсДдФфГгХхЈјКкЛлЧчЋћЅѕЏџЦцВвБбНнМм,-_ ]*$/
);
export const validDecimalRegex = RegExp(
  /^([1-9][0-9]{0,5})(\.|\,)?((\d){0,2})$/
);
export const validLat = RegExp(/^[0-9a-zA-ZŽžĐđŠšĆćČč,-_ ]*$/);

export const validEn = RegExp(/^[0-9a-zA-Z,-_ ]*$/);

export const validLettersNumber = RegExp(
  /^[0-9a-zA-ZŽžĐđŠšĆćČčЉљЊњЕеРрТтЗзУуИиОоПпШшЂђЖжАаСсДдФфГгХхЈјКкЛлЧчЋћЅѕЏџЦцВвБбНнМм]*$/
);
export const validNameandNumberEngMneRegex = RegExp(
  /^[.,:;A-Za-z0-9-_ŠšĐđČčĆćŽž ]*$/
);
export const validNameandNumberEngMneSymbolsRegex = RegExp(
  /^[€.,:;A-Za-z0-9-_ŠšĐđČčĆćŽž ]*$/
);
export const validNameAndNumberRegex = RegExp(
  /^[.A-Za-z0-9-_ŠšĐđČčĆćŽžШшџЏЂђЧчЋћЖжЉљЊњаАбБвВгГдДејЈЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦџЏчЧѕЅшШщЩъЪыЫьЬэЭюЮяЯЉљЊњХх ]*$/
);

export const validFolderNameRegex = RegExp(
  /^[.A-Za-z0-9-_ŠšĐđČčĆćŽžШшџЏЂђЧчЋћЖжЉљЊњаАбБвВгГдДејЈЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦџЏчЧѕЅшШщЩъЪыЫьЬэЭюЮяЯЉљЊњХх/ ]*$/
);

export const validDate = RegExp(
  /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\.\s*$/
);

export const descriptionFieldRegex = RegExp(
  /^[.,A-Za-z0-9-_ŠšĐđČčĆćŽžШшџЏЂђЧчЋћЖжЉљЊњаАбБвВгГдДејЈЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦџЏчЧѕЅшШщЩъЪыЫьЬэЭюЮяЯЉљЊњХх ]*$/
);

export const validNameNumberSymbolsRegex = RegExp(
  /^[.A-Za-z0-9-!,/_?=+()*&%ŠšĐđČčĆćŽžШшџЏЂђЧчЋћЖжЉљЊњаАбБвВгГдДејЈЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦџЏчЧѕЅшШщЩъЪыЫьЬэЭюЮяЯЉљЊњХх \n\r]*$/
);

export const validCommentsRegex = RegExp(
  /^[.A-Za-z0-9-!,/-_?=+()*&%ŠšĐđČčĆćŽžШшџЏЂђЧчЋћЖжЉљЊњаАбБвВгГдДејЈЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦџЏчЧѕЅшШщЩъЪыЫьЬэЭюЮяЯЉљЊњХх"'` \n\r]*$/
);

export const validNameNumberSymbolsRegex2 = RegExp(
  /^[.A-Za-z0-9-,"'*&%ŠšĐđČčĆćŽžШшџЏЂђЧчЋћЖжЉљЊњаАбБвВгГдДејЈЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦџЏчЧѕЅшШщЩъЪыЫьЬэЭюЮяЯЉљЊњХх ]*$/
);

// 1 - 9, 01 - 99 are valid, 0, 00, 100, 123 are not valid
export const validTwoDigitNumber = RegExp(/^(0?[1-9]|[1-9][0-9])$/);
export const dateRegex = RegExp(
  /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
);

export const noSpaceWithUnderscoreAllCaps = RegExp(/^[A-Z]+(?:_[A-Z]+)*$/);

export const validPhoneNumberRegex = RegExp(/^[\+0][0-9]{5,14}$/);

export const validURL = RegExp(
  /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/
);

export const validGlobalURL = RegExp(
  /https?|http?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
);

export const validLatEnOrPositiveDouble = RegExp(
  /(([a-zA-ZŽžĐđŠšĆćČč,_ ]+[a-zA-Z,_ ])|(^\d+([.]\d{0,2})?$))/
);

//return some date format
export const toDate = (date, format) => {
  return moment(date).format(format);
};

export const createDocumentFromBlob = (data, documentName) => {
  const downloadUrl = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', documentName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
export const createXLSXFromBlob = (data, documentName) => {
  const downloadUrl = window.URL.createObjectURL(
    new Blob([data], {type: 'application/x-www-form-urlencoded; charset=UTF-8'})
  );
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', documentName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};


